export default __webpack_public_path__ + "static/media/wf_icon_small_light.16119b06.svg";